//GERADE
//classic
import classic_1102_gerade from "./classic/1102CL.png";
import classic_1101_gerade from "./classic/1101CL.png";
import classic_1103_gerade from "./classic/1103CL.png";
import classic_1104_gerade from "./classic/1104CL.png";
//modern
import modern_1202_gerade from './modern/1202M.png';
import modern_1203_gerade from './modern/1203M.png';
import modern_1204_gerade from './modern/1204M.png';
import modern_1205_gerade from './modern/1205M.png';
import modern_1206_gerade from './modern/1206M.png';
import modern_1207_gerade from './modern/1207M.png';
import modern_1208_gerade from './modern/1208M.png';
import modern_1209_gerade from './modern/1209M.png';
import modern_1210_gerade from './modern/1210M.png';
import modern_1201_gerade from './modern/1201M.png';
//luxus
import luxus_1301_gerade from './luxus/1301L.png';
import luxus_1302_gerade from './luxus/1302L.png';
import luxus_1303_gerade from './luxus/1303L.png';
import luxus_1304_gerade from './luxus/1304L.png';
import luxus_1305_gerade from './luxus/1305L.png';

//GESCHWUNGEN
//classic
import classic_1101_geschwungen from "./classic/1101CL_geschwungen.png";
import classic_1103_geschwungen from "./classic/1103CL_geschwungen.png";
//modern
import modern_1201_geschwungen from './modern/1201M_geschwungen.png';
import modern_1202_geschwungen from './modern/1202M_geschwungen.png';
import modern_1203_geschwungen from './modern/1203M_geschwungen.png';
import modern_1204_geschwungen from './modern/1204M_geschwungen.png';
import modern_1205_geschwungen from './modern/1205M_geschwungen.png';
import modern_1206_geschwungen from './modern/1206M_geschwungen.png';
import modern_1207_geschwungen from './modern/1207M_geschwungen.png';
//luxus
import luxus_1301_geschwungen from './luxus/1301L_geschwungen.png';
import luxus_1302_geschwungen from './luxus/1302L_geschwungen.png';
import luxus_1303_geschwungen from './luxus/1303L_geschwungen.png';
import luxus_1304_geschwungen from './luxus/1304L_geschwungen.png';
import luxus_1305_geschwungen from './luxus/1305L_geschwungen.png';

export const muster_gerade = [
    {product_img: classic_1101_gerade, titel: 'Modell - 1101C', form: 'Gerade'},
    {product_img: classic_1102_gerade, titel: 'Modell - 1102C', form: 'Gerade'},
    {product_img: classic_1103_gerade, titel: 'Modell - 1103C', form: 'Gerade'},
    {product_img: classic_1104_gerade, titel: 'Modell - 1104C', form: 'Gerade'},
    {product_img: modern_1201_gerade, titel: 'Modell - 1201MG', form: 'Gerade'},
    {product_img: modern_1202_gerade, titel: 'Modell - 1202MG', form: 'Gerade'},
    {product_img: modern_1203_gerade, titel: 'Modell - 1203MG', form: 'Gerade'},
    {product_img: modern_1204_gerade, titel: 'Modell - 1204MG', form: 'Gerade'},
    {product_img: modern_1205_gerade, titel: 'Modell - 1205MG', form: 'Gerade'},
    {product_img: modern_1206_gerade, titel: 'Modell - 1206MG', form: 'Gerade'},
    {product_img: modern_1207_gerade, titel: 'Modell - 1207MG', form: 'Gerade'},
    {product_img: modern_1208_gerade, titel: 'Modell - 1208MG', form: 'Gerade'},
    {product_img: modern_1209_gerade, titel: 'Modell - 1209MG', form: 'Gerade'},
    {product_img: modern_1210_gerade, titel: 'Modell - 1210M', form: 'Gerade'},
    {product_img: luxus_1301_gerade, titel: 'Modell - 1301L', form: 'Gerade'},
    {product_img: luxus_1302_gerade, titel: 'Modell - 1302L', form: 'Gerade'},
    {product_img: luxus_1303_gerade, titel: 'Modell - 1303L', form: 'Gerade'},
    {product_img: luxus_1304_gerade, titel: 'Modell - 1304L', form: 'Gerade'},
    {product_img: luxus_1305_gerade, titel: 'Modell - 1305L', form: 'Gerade'}
]

export const muster_geschwungen = [
    {product_img: classic_1101_geschwungen, titel: 'Modell - 1101C', form: 'Geschwungen'},
    {product_img: classic_1103_geschwungen, titel: 'Modell - 1103C', form: 'Geschwungen'},
    {product_img: modern_1201_geschwungen, titel: 'Modell - 1201M', form: 'Geschwungen'},
    {product_img: modern_1202_geschwungen, titel: 'Modell - 1202M', form: 'Geschwungen'},
    {product_img: modern_1203_geschwungen, titel: 'Modell - 1203M', form: 'Geschwungen'},
    {product_img: modern_1204_geschwungen, titel: 'Modell - 1204M', form: 'Geschwungen'},
    {product_img: modern_1205_geschwungen, titel: 'Modell - 1205M', form: 'Geschwungen'},
    {product_img: modern_1206_geschwungen, titel: 'Modell - 1206M', form: 'Geschwungen'},
    {product_img: modern_1207_geschwungen, titel: 'Modell - 1207M', form: 'Geschwungen'},
    {product_img: luxus_1301_geschwungen, titel: 'Modell - 1301C', form: 'Geschwungen'},
    {product_img: luxus_1302_geschwungen, titel: 'Modell - 1302C', form: 'Geschwungen'},
    {product_img: luxus_1303_geschwungen, titel: 'Modell - 1303C', form: 'Geschwungen'},
    {product_img: luxus_1304_geschwungen, titel: 'Modell - 1304C', form: 'Geschwungen'},
    {product_img: luxus_1305_geschwungen, titel: 'Modell - 1305C', form: 'Geschwungen'}
]